var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 22.5,
    stroke: "#004494",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 10.0375C26.465 10.0375 28.4625 12.035 28.4625 14.5C28.4625 16.965 26.465 18.9625 24 18.9625C21.535 18.9625 19.5375 16.965 19.5375 14.5C19.5375 12.035 21.535 10.0375 24 10.0375ZM24 29.1625C30.3113 29.1625 36.9625 32.265 36.9625 33.625V35.9625H11.0375V33.625C11.0375 32.265 17.6887 29.1625 24 29.1625ZM24 6C19.3037 6 15.5 9.80375 15.5 14.5C15.5 19.1963 19.3037 23 24 23C28.6963 23 32.5 19.1963 32.5 14.5C32.5 9.80375 28.6963 6 24 6ZM24 25.125C18.3262 25.125 7 27.9725 7 33.625V40H41V33.625C41 27.9725 29.6738 25.125 24 25.125Z",
    fill: "#004494"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.b148150c0a5ed87017feef90b458203d.svg";
export { ForwardRef as ReactComponent };